import React from 'react';
import { Box } from '@mui/material';
import useScrollReveal from '../hooks/useScrollReveal';

/**
 * Scroll-reveal wrapper used on marketing pages.
 * @param {{ children: React.ReactNode, direction?: 'left' | 'right', className?: string }} props
 */
const RevealPanel = ({ children, direction = 'left', className = '' }) => {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.18 });
  const revealClass =
    direction === 'right' ? 'scroll-reveal-right' : 'scroll-reveal-left';

  return (
    <Box
      ref={ref}
      className={`${revealClass} ${isVisible ? 'is-visible' : ''} ${className}`.trim()}
      sx={{ minWidth: 0, maxWidth: '100%', overflow: 'hidden' }}
    >
      {children}
    </Box>
  );
};

export default RevealPanel;
